import { render } from "./ProfileHeader.vue?vue&type=template&id=7b478df4&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=7b478df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b478df4"]])

export default __exports__